import {Intake, UserGender, Weekday, Weekend} from '@/enums';
import {GenderOptionItem, GenderOptions} from "@/types";

export function getDanishDay(day: Weekday | Weekend): string {
	switch (day) {
		case Weekday.MONDAY:
			return 'mandag';
		case Weekday.TUESDAY:
			return 'tirsdag';
		case Weekday.WEDNESDAY:
			return 'onsdag';
		case Weekday.THURSDAY:
			return 'torsdag';
		case Weekday.FRIDAY:
			return 'fredag';
		case Weekday.SATURDAY:
			return 'lørdag';
		case Weekday.SUNDAY:
			return 'søndag';
		default:
			console.error('GetDanishDay: Weekday not recognized: ' + day);
			return '';
	}
}

export function getDanishWeekDays(): string[] {
	return ['mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag'];
}

export function getDanishWeekendDays(): string[] {
	return ['lørdag', 'søndag'];
}

export function getDayAsBytes(day: string): number {
	switch (day) {
		case Weekday.MONDAY:
		case getDanishDay(Weekday.MONDAY):
			return 1;
		case Weekday.TUESDAY:
		case getDanishDay(Weekday.TUESDAY):
			return 2;
		case Weekday.WEDNESDAY:
		case getDanishDay(Weekday.WEDNESDAY):
			return 4;
		case Weekday.THURSDAY:
		case getDanishDay(Weekday.THURSDAY):
			return 8;
		case Weekday.FRIDAY:
		case getDanishDay(Weekday.FRIDAY):
			return 16;
		case Weekday.SATURDAY:
		case getDanishDay(Weekday.SATURDAY):
			return 32;
		case Weekday.SUNDAY:
		case getDanishDay(Weekday.SUNDAY):
			return 64;
	}

	return 0;
}

export function round(value: number, decimals: number): number {
	const factor = Math.pow(10, decimals);
	return Math.round(value * factor) / factor;
}

//@ts-ignore
export function t(category, message, params = null) {
	//@ts-ignore
	return LanguageManager.t(category, message, params);
}

export function unitToIntake(unit: string): Intake {
	if (unit === 'g' || unit === 'portion') {
		return Intake.FOOD;
	} else {
		return Intake.DRINKS;
	}
}


export function unitToIntakePortion(unit: string): Intake {
	if (unit === 'g' || unit === 'portion') {
		return Intake.FOOD_PORTIONS;
	} else {
		return Intake.DRINKS_PORTIONS;
	}
}

export function getDanishGender(gender: UserGender): string {
	switch (gender) {
		case UserGender.GENDER_FEMALE:
			return t('userData', 'woman');
		case UserGender.GENDER_MALE:
			return t('userData', 'man');
		case UserGender.GENDER_OTHER:
			return t('userData', 'other');
		default:
			console.error('getDanishGender: gender not recognized: ' + gender);
			return '';
	}
}

export function getDanishGenderObject(): GenderOptions {

	const genderItemFemale: GenderOptionItem = {
		value: UserGender.GENDER_FEMALE,
		label: getDanishGender(UserGender.GENDER_FEMALE)
	}
	const genderItemMale: GenderOptionItem = {
		value: UserGender.GENDER_MALE,
		label: getDanishGender(UserGender.GENDER_MALE)
	}
	const genderItemOther: GenderOptionItem = {
		value: UserGender.GENDER_OTHER,
		label: getDanishGender(UserGender.GENDER_OTHER)
	}

	const genderObject: GenderOptions = {
		female: genderItemFemale,
		male: genderItemMale,
		other: genderItemOther,
	};

	return genderObject;
}
